import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import styles from './Gamefield.scss'

const Gamefield = (props) => {
    const className = classNames(styles.base, {
        [styles.base__external]: props.type === 'external',
    })
    return (
        <div className={className}>{props.children}</div>
    )
}

Gamefield.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.array,
    ]).isRequired,
    type: PropTypes.oneOf(['external']),
}

Gamefield.TYPES = {
    external: 'external',
}

export default Gamefield



// WEBPACK FOOTER //
// ./components/Gamefield/Gamefield.jsx